<template>
  <v-tabs
    :value="selectedTabId"
    class="risk-tabs"
    :is="statsStore.selectedRiskCategory"
  >
    <v-tab
      v-for="tab in allTabs"
      :value="tab.id"
      @click="emitSelectedTab(tab.id)"
      >{{ tab.label }} ({{ tab.count }})
    </v-tab>
  </v-tabs>
</template>

<script setup lang="ts">
import type { Tab } from "@/models/tab";
import { useStatsStore } from "@/stores/statsStore";

const statsStore = useStatsStore();

const props = defineProps<{
  allTabs: Tab[];
  selectedTabId: string;
}>();

const emit = defineEmits<{
  (e: "selectedTab", tabId: string): void;
}>();

function emitSelectedTab(tabId: string) {
  emit("selectedTab", tabId);
}
</script>

<style scoped lang="scss">
.risk-tabs[is="LabourAndHumanRights"] {
  :deep(.v-tab--selected) {
    color: var(--blue-violet) !important;
  }
}
.risk-tabs[is="HealthAndSafety"] {
  :deep(.v-tab--selected) {
    color: var(--blue) !important;
  }
}
.risk-tabs[is="Environment"] {
  :deep(.v-tab--selected) {
    color: var(--dark-green) !important;
  }
}
.risk-tabs[is="BusinessIntegrity"] {
  :deep(.v-tab--selected) {
    color: var(--red-orange) !important;
  }
}
.risk-tabs[is="SupplierManagement"] {
  :deep(.v-tab--selected) {
    color: var(--dark-yellow) !important;
  }
}
</style>
